import { notify } from "@kyvg/vue3-notification";

export default {
    err: (m, title = null) => {
        if (m?.response) m = m.response;
        console.error(m);
        if (typeof m == "object") {
            try {
                // 認証エラーの場合は何もメッセージがなければログアウトさせる
                if (! m.data.message && m.status == 401 && location.pathname != "/login") {
                    location.href = "/login";
                    return;
                }
                // エラーメッセージバッグはまとめる
                let message = m.data.message || m.data || m.statusText;
                // セッション切れ
                if (message == "CSRF token mismatch." || message == "Unauthenticated.") {
                    message = "セッションが切れました。ページを再読込します。";
                    setTimeout("location.href = '/'", 5000);
                }
                if (m.data.errors) {
                    let errors = [];
                    for (let key in m.data.errors) {
                        errors.push(m.data.errors[key]);
                    }
                    message = errors.join("<br>");
                }
                m = message;
            } catch (error) {
            }
        }
        notify({
            group: "main",
            type: "error",
            duration: 20000,
            title: title,
            text: m,
        });
    },
    msg: (m, title = null) => {
        notify({
            group: "main",
            type: "success",
            duration: 10000,
            title: title,
            text: m,
        });
    },
    warn: (m, title = null, duration = 20) => {
        notify({
            group: "main",
            type: "warn",
            duration: duration * 1000,
            title: title,
            text: m,
        });
    }
}